$(document).ready(function(){

	$('a[href^="#"], .scrollTop a').on('click', function(e){
		e.preventDefault();
		
		var id = $(this).attr("href");
	
		$('html, body').animate({
			scrollTop: $(id).offset().top - 50
		}, 'slow');
		return false;
	});

});